export default function ProductLoader () {
    return (
        <div className="col-sm-6 g-2 g-sm-3 g-md-4">
            <div className="border px-0 py-1 rounded-3 row m-0">
                <div className="col-9 col-md-8">
                    <span className="placeholder placeholder-wave bg-secondary col-6"></span><br />
                    <span className="placeholder placeholder-wave bg-secondary col-8"></span><br />
                </div>
                <div className="col-3 col-md-4 position-relative">
                    <div style={{aspectRatio: "1/1", maxWidth: "100px", minWidth: "50px"}} className="bg-dark-subtle rounded-3 float-end my-2 w-100 shadow-sm"></div>
                </div>
            </div>
        </div>
    )
}